import _ from 'lodash';

import { PATH } from '../constants/path';
import { DEFAULT_LOCALE } from '../constants/locale';
import { COIN_NAME, USE_PARITY } from '../constants/ebon';

/**
 * Retourne true si l'url est une url extérieur à l'application
 * @param {String url} url
 */
export function isUrlExterieur(url) {
    return url && (_.startsWith(url, 'http') || _.startsWith(url, 'www'));
}

/**
 * Ajoute 'http://' devant une url extérieur avec seulement www au début
 * @param {String} url
 */
export function reformUrlExterieur(url) {
    let retour = url;
    if (isUrlExterieur(url) && _.startsWith(url, 'www')) {
        return 'http://' + url;
    }
    return retour;
}

/**
 * Retourne un tableau avec l'alphabet
 */
export function getAlphabet() {
    return _.range('a'.charCodeAt(0), 'z'.charCodeAt(0) + 1).map(charCode =>
        String.fromCharCode(charCode)
    );
}

/**
 * Retourne un tableau avec 123 en premier et ensuite l'alphabet
 */
export function getAlphabetAnd123() {
    return ['123', ...getAlphabet()];
}

/**
 * Retourne un FormData en fonction d'un json en entrée
 */
export const getFormDataFromJson = object =>
    Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());

/**
 * Retourne l'url vers l'instertitiel coupon
 * TODO à bouger dans la future feature interstitiel. Créer un utils avec toutes les fonctions pour créer des urls d'interstitiems
 */
export function getInstertitielCouponUrl({ idPartenaire, idCoupon }) {
    return idCoupon && idPartenaire
        ? `${PATH.INTERSTITIEL_REDUCTION_PATH}${idPartenaire}/-8/${idCoupon}`
        : '';
}

/**
 * Return pathname with params join with &
 * @param {*String} pathname
 * @param {*Object} params object containing { [param name]: value }
 */
export const addParamsToPathname = (pathname, params = {}) =>
    pathname.concat('?').concat(
        Object.keys(params)
            .reduce((res, curr) => {
                res.push(`${curr}=${params[curr]}`);
                return res;
            }, [])
            .join('&')
    );

export const isNormalInteger = str => {
    return /^\+?(0|[1-9]\d*)$/.test(str);
};

export const truncateAmount = amount => {
    // Truncate to 4 decimal places without rounding
    const roundedAmount = Math.floor(amount * 10000) / 10000;
    // Convert to string
    const stringAmount = roundedAmount.toString();
    // Separate the integer part and the decimal part
    const splitedAmount = stringAmount.split('.');
    // If the decimal part exists and has more than 2 digits, shorten it
    if (splitedAmount.length === 2 && splitedAmount[1].length > 2) {
        splitedAmount[1] = splitedAmount[1].substring(0, 2);
    }
    // Join the integer part and the decimal part
    return parseFloat(splitedAmount.join('.'));
};

export const formatAmount = str => {
    return (
        str.toLocaleString(navigator.language, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' €'
    );
};

export const formatAmountCurrency = amount => {
    const truncatedAmount = truncateAmount(amount);

    return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'EUR'
    }).format(truncatedAmount);
};

export const formatAmountParity = amount => {
    return `${amount} ${COIN_NAME}`;
};

export const getParityTotal = (total, amountCashback) => {
    if (USE_PARITY) return Math.floor(total / 10) * amountCashback;
};

export const renderConditionalOrNothing = (str, condition) =>
    str && condition && condition() ? str : null;

export const toi18nKey = str => _.toUpper(_.snakeCase(str));

export const scrollToAnchor = location => {
    const { hash } = location;
    if (hash) {
        setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) element.scrollIntoView();
        }, 250);
    }
};

export const addLocaleToPathIfNeeded = ({ locale, to }) => {
    if (isUrlExterieur(to)) {
        return reformUrlExterieur(to);
    } else {
        return `${locale !== DEFAULT_LOCALE ? `/${locale}` : ''}${to}`;
    }
};

export const formatNumber = (number, locale) => number.toLocaleString(locale);

export const getPartnerIdFromQuery = query => _.last(query.split('-'));
export const getPartnerNameFromQuery = query => _.initial(query.split('-')).join('-');

export const mapCountries = countries => {
    if (!_.isEmpty(countries)) {
        return Object.values(countries).map(country => {
            return {
                label: country.label,
                value: country.value
            };
        });
    }
    return {};
};



// WEBPACK FOOTER //
// ./src/utils/index.js